import Entity from "@/entities/entity";
export default class MissingSubmission {
    id: number;
    description: string;
    period_year: number;
    period_month: number;
    entity: Entity;


    constructor(values: MissingSubmissionConstructorValues) {
        this.id = values.id
        this.description = values.description
        this.period_year = values.period_year
        this.period_month = values.period_month
        this.entity = values.entity

    }
}


export interface MissingSubmissionConstructorValues {
    id: number;
    description: string;
    period_year: number;
    period_month: number;
    entity: Entity
}
